import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import StatisticService from "../../../../services/reservations/StatisticService";

export const REQUEST_GENERATE_STATISTIC = "REQUEST_GENERATE_STATISTIC";
export const GENERATE_STATISTIC_SUCCESS = "GENERATE_STATISTIC_SUCCESS";
export const GENERATE_STATISTIC_ERROR = "GENERATE_STATISTIC_ERROR";
export const INITIAL_STATE_STATISTIC = "INITIAL_STATE_STATISTIC";

function requestGenerateStatistic() {
  return {
    type: REQUEST_GENERATE_STATISTIC,
  };
}

function generateStatisticSuccess(json) {
  return {
    type: GENERATE_STATISTIC_SUCCESS,
    data: json,
  };
}

function generateStatisticError(json) {
  return {
    type: GENERATE_STATISTIC_ERROR,
    error: json.data,
  };
}

export function initialStateStatistic() {
  return {
    type: INITIAL_STATE_STATISTIC,
  };
}

export function generateStatistic(startDate, endDate, type, payload) {
  return (dispatch) => {
    dispatch(requestGenerateStatistic());
   return StatisticService.statisticReport(startDate, endDate, type, payload)
      .then((response) => {
        if (response.status === 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;

          link.setAttribute("download", "Estadísctica.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);

          dispatch(generateStatisticSuccess("Descarga completada"));
        } else if (response.data.code === 202) {
          updateLocalStorageToken(response.data.token);
          dispatch(generateStatistic(startDate, endDate, type, payload));
        } else if (response.data.code === 498) {
          logOut();
        } else {
          dispatch(generateStatisticError(response.data));
        }
      })
      .catch((error) => {
        dispatch(generateStatisticError(error));
      });
  };
}
